import { render, staticRenderFns } from "./ContactFormDemo.vue?vue&type=template&id=91177c60&scoped=true&"
import script from "./ContactFormDemo.vue?vue&type=script&lang=ts&"
export * from "./ContactFormDemo.vue?vue&type=script&lang=ts&"
import style0 from "./ContactFormDemo.vue?vue&type=style&index=0&id=91177c60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91177c60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
